module.exports = __webpack_public_path__ + "static/fonts/Baskvill.9ecec61.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Baskvill.ttf
// module id = 967
// module chunks = 113